import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ContentLayoutComponent } from './components/layout/content-layout/content-layout.component';
import { FullLayoutComponent } from './components/layout/full-layout/full-layout.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AppConfirmComponent } from './components/app-confirm/app-confirm.component';
import { AppLoaderComponent } from './components/app-loader/app-loader.component';
import { AppConfirmService } from './components/app-confirm/app-confirm.service';
import { AppLoaderService } from './components/app-loader/app-loader.service';

@NgModule({
  declarations: [
    FooterComponent, 
    HeaderComponent, 
    SidebarComponent, 
    ContentLayoutComponent, 
    FullLayoutComponent,
    BreadcrumbComponent, 
    AppConfirmComponent,
    AppLoaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,   
    HttpClientModule,
    SharedModule   
  ],
  providers: [    
    AppConfirmService,
    AppLoaderService
  ],
  exports: [
    FooterComponent, 
    HeaderComponent, 
    SidebarComponent, 
    ContentLayoutComponent, 
    FullLayoutComponent,
    BreadcrumbComponent
  ]
})
export class CoreModule { }
